import { Component } from '@angular/core';
import { BlockBaseComponent } from "../block-base/block-base.component";
import { StoreSelectorsService } from "../../../../services/store-selectors.service";
import { MatDialog } from "@angular/material/dialog";
import { TranslocoService } from "@ngneat/transloco";
import { ToastrService } from 'ngx-toastr';
import { isValidUrl } from 'app/common';


@Component({
    selector: 'app-block-canva',
    templateUrl: './block-canva.component.html',
    styleUrls: ['./block-canva.component.scss']
})
export class BlockCanvaComponent extends BlockBaseComponent {
    constructor(
        private translocoService: TranslocoService, 
        public override storeSelector: StoreSelectorsService,
        private toastr: ToastrService,
        ) {
        super(storeSelector);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.embeddedLink', {}, this.translocoService.getActiveLang()),
                inputType: "textarea",
                name: "embeddedLink",
                storePath: 'Data[0].Canva[0].$.embeddedLink'
            },
        ];
    }

    override submit(formValues) {
        // const previousUrl = this.sceneItem.Data[0].Canva?.[0]?.$?.embeddedLink;
        const newUrl = formValues.embeddedLink || '';
        if (newUrl && (!newUrl.startsWith('https://www.canva.com/design') || !isValidUrl(newUrl) || newUrl.indexOf('?') > 0)) {
            this.toastr.warning('invalid canva embedded link. please copy and paste again.');
            return;
        }
        super.submit(formValues);
    }
}
